import React from "react";
import { useCreateVenue } from "../../entities/api";
import AddAndEditVenueModal from "./AddAndEditVenueModal";

const AddVenue = (props) => {
  const { isModalOpen, handleClose, onAdd } = props;
  const { mutateAsync: createFn, isPending: isCreatePending } = useCreateVenue();

  const handleSendRequest = async (form) => {
    try {
      const data = await form.validateFields();
      const res = await createFn({
        ...data,
      });
      onAdd?.(res?.data?.[0]);
      handleClose();
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <>
      <AddAndEditVenueModal
        {...props}
        openModal={isModalOpen}
        handleCloseModal={handleClose}
        handleSendRequest={handleSendRequest}
        okButtonLoading={isCreatePending}
      />
    </>
  );
};

export default AddVenue;
